import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services';
import { useApp } from '../AppContext';
import BookGrid from './BookGrid';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function BookSlider({ books = [], sliderTitle = '' }) {
    const navigate = useNavigate();

    const goToBookDetails = (book) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate('/book-details', { state: { book } });
    };
    if (!books || books.length === 0) {
        return null; // Or return a small spinner container
    }
    return (
        <>
            <section className="py-5 bg-light-green">
                <div className="container-fluid px-4 px-lg-5 ">
                    <h2 className="fw-bolder mb-4">{sliderTitle}</h2>
                    <Swiper
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={2}
                        navigation
                        autoplay={{ delay: 3000 }}
                        breakpoints={{
                            640: { slidesPerView: 3 },
                            1024: { slidesPerView: 6 },
                        }}
                        className=""
                    >
                        {books.map((book) => (
                            <SwiperSlide key={book.id}>
                                <div className="card h-100 shadow border-0 testing">
                                    <div className="card-body p-4">
                                        <BookGrid
                                            books={book}
                                            onlyImage={true}
                                            onViewBook={(book) => {
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                                navigate('/book-details', { state: { book } });
                                            }}
                                        />
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </>
    )
}
